"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PixelToJSON = exports.PixelFromJSONTyped = exports.PixelFromJSON = exports.instanceOfPixel = void 0;
var runtime_1 = require("../runtime");
var Event_1 = require("./Event");
var HistoricalEvent_1 = require("./HistoricalEvent");
/**
 * Check if a given object implements the Pixel interface.
 */
function instanceOfPixel(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfPixel = instanceOfPixel;
function PixelFromJSON(json) {
    return PixelFromJSONTyped(json, false);
}
exports.PixelFromJSON = PixelFromJSON;
function PixelFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'domain': !(0, runtime_1.exists)(json, 'domain') ? undefined : json['domain'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'createdAt': !(0, runtime_1.exists)(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'events': !(0, runtime_1.exists)(json, 'events') ? undefined : (json['events'].map(Event_1.EventFromJSON)),
        'historicalEvents': !(0, runtime_1.exists)(json, 'historical_events') ? undefined : (json['historical_events'].map(HistoricalEvent_1.HistoricalEventFromJSON)),
        'datasetId': !(0, runtime_1.exists)(json, 'dataset_id') ? undefined : json['dataset_id'],
    };
}
exports.PixelFromJSONTyped = PixelFromJSONTyped;
function PixelToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'domain': value.domain,
        'name': value.name,
        'dataset_id': value.datasetId,
    };
}
exports.PixelToJSON = PixelToJSON;
